<template>
  <div class="col-md-12 col-xs-12" :id="`category-${category.entity_id}`">
    <h3>{{ $t(category.name) }}</h3>
    <swiper class="swiper relative" :options="swiperOption" ref="shopGiftProducts">
      <swiper-slide v-for="item in giftsProduct" :key="item._source.id" class="slider-block-slide">
        <gifts-box-product :product="item._source"/>
      </swiper-slide>
      <div v-if="showArrow" @click="showPrevious" class="swiper-button-prev swiper-button" slot="button-prev"></div>
      <div v-if="showArrow" @click="showNext" class="swiper-button-next swiper-button" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import GiftsBoxProduct from "./GiftsBoxProduct";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: "GiftsBoxCategoryProducts",
  components: {
    Swiper,
    SwiperSlide,
    GiftsBoxProduct
  },
  props: {
    category: {
      type: Object
    }
  },
  mounted () {
    if (this.category && this.category.hasOwnProperty('id')) {
      this.$store.dispatch('products_categories/updateProducts', { store: this.partner.code, location_code: this.partner.location_code, size: 12, categoryIds: this.category.categoryIds, category: this.category })
    }
  },
  watch: {
    giftsProduct: {
      handler() {
        if (this.giftsProduct && this.giftsProduct.length) {
          this.giftsProduct.forEach(product => {
            product._source.final_price = product._source.price
            product._source.qty = 1
          })
        }
      }
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1200: {
            slidesPerView: 3
          },
          991: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2
          },
          465: {
            slidesPerView: 1
          },
          0: {
            slidesPerView: 1
          }
        },
        loop: false
      }
    }
  },
  computed: {
    partner () {
      return this.$store.getters['partners/getCurrentPartner'];
    },
    giftsProduct () {
      if (this.$store.getters['partners/getCurrentPartner'] && this.$store.getters['partners/getCurrentPartner'].hasOwnProperty('root_category_id')) {
        let category = this.$store.getters['products_categories/categoriesProducts'].find(category => category.category.entity_id ===  this.category.entity_id)
        return category && category.hasOwnProperty('products') ? category.products : []
      }
      return []
    },
    showArrow () {
      if (this.giftsProduct.length > 1 && window.innerWidth <= 465) {
        return true
      } else if (this.giftsProduct.length > 2 && window.innerWidth <= 991) {
        return true
      } else if (this.giftsProduct.length > 3) {
        return true
      }
      return false
    }
  },
  methods: {
    showPrevious () {
      this.$refs.shopGiftProducts.$swiper.slidePrev()
      this.endSlider = false
    },
    showNext () {
      this.$refs.shopGiftProducts.$swiper.slideNext()
    }
  }
}
</script>

<style scoped>
  .swiper-button {
    color: #08bc2a;
    top: 250px;
  }
</style>
